export default __webpack_public_path__ + "static/media/Active_Quote.a828c519.svg";